<template>
    <div>
        <el-row :gutter = "20">
            <el-col :span = "6" >
                  <el-card @click.native="getUnitPatrolling" :shadow="shadow.getUnitPatrollingshadow" :class="classStyle.getUnitPatrollingVClassStyle">
                      <div>
                          单位巡查统计
                      </div>
                  </el-card>  
            </el-col>
            <el-col :span = "6" >
                <el-card @click.native="getHiddenDangerSection" :shadow="shadow.getHiddenDangerSectionshadow" :class="classStyle.getHiddenDangerSectionClassStyle">
                      <div>
                          隐患标段统计
                      </div>
                  </el-card> 
            </el-col>
            <el-col :span = "6" >
                <el-card @click.native="getTaskAssignment" :shadow="shadow.getTaskAssignmentshadow" :class="classStyle.getTaskAssignmentClassStyle">
                      <div>
                          任务分派统计
                      </div>
                  </el-card> 
            </el-col>
            <el-col :span = "6" >
                <el-card @click.native="getProcessingConditions" :shadow="shadow.getProcessingConditionsshadow" :class="classStyle.getProcessingConditionsClassStyle" >   
                      <div>
                          处理状况统计
                      </div>
                  </el-card> 
            </el-col>
        </el-row>
        <div style="height: 100px">
        </div>
        <div id="mychart" style="width: 600px;height:400px; margin:0 auto"></div>
    </div>
</template>

<script>
import lccreq from '@/api/lcc'
import * as echarts from 'echarts';
import { log } from 'three';
export default {
    data() {
        return{
            option: {
                title: {
                    text: '',
                    left: 'center'
                },
                tooltip: {
                    trigger: 'item'
                },
                legend: {
                    orient: 'vertical',
                    left: 'left',
                },
                series: [
                    {
                        name: '访问来源',
                        type: 'pie',
                        radius: '50%',
                        data: [],
                        label: {
                            normal: {
                                show: true,
                                formatter: '{b}: {c}({d}%)' //自定义显示格式(b:name, c:value, d:百分比)
                            }
                        },
                        emphasis: {
                            itemStyle: {
                                shadowBlur: 10,
                                shadowOffsetX: 0,
                                shadowColor: 'rgba(0, 0, 0, 0.5)'
                            }
                        }
                    }
                ],
            },
            shadow: {
                getUnitPatrollingshadow: "hover",
                getHiddenDangerSectionshadow: "hover",
                getTaskAssignmentshadow: "hover",
                getProcessingConditionsshadow: "hover",
            },
            classStyle:{
                getUnitPatrollingVClassStyle: "",
                getHiddenDangerSectionClassStyle:"",
                getTaskAssignmentClassStyle:"",
                getProcessingConditionsClassStyle: ""
            }
        }

    },
    mounted() {
        this.getUnitPatrolling();
    },
    methods: {
        getUnitPatrolling(){
            this.shadow.getUnitPatrollingshadow = "always";
            this.classStyle.getUnitPatrollingVClassStyle = "classStyle";
            this.shadow.getHiddenDangerSectionshadow = "hover";
            this.shadow.getTaskAssignmentshadow = "hover";
            this.shadow.getProcessingConditionsshadow = "hover";
            this.classStyle.getTaskAssignmentClassStyle = "";
            this.classStyle.getProcessingConditionsClassStyle = ""
            this.classStyle.getHiddenDangerSectionClassStyle = ""

            var chartDom = document.getElementById('mychart');
            var myChart = echarts.init(chartDom);
            let data = []
            lccreq.getUnitPatrolling().then(res =>{
                if(res.code == 200){
                    console.log(res.data.data)
                    for(let key in res.data.data){
                      let temp =  {
                            value: res.data.data[key],
                            name: key
                        }
                        data.push(temp)
                    }
                    this.option.series[0].data = [].concat(data)
                    this.option.title.text = '单位巡查统计'
                    myChart.setOption(this.option)
                }
            })
        },
        getHiddenDangerSection(){
            this.shadow.getHiddenDangerSectionshadow = "always";
            this.classStyle.getHiddenDangerSectionClassStyle = "classStyle"
            this.shadow.getUnitPatrollingshadow = "hover";
            this.shadow.getTaskAssignmentshadow = "hover";
            this.shadow.getProcessingConditionsshadow = "hover";
            this.classStyle.getUnitPatrollingVClassStyle = "";
            this.classStyle.getTaskAssignmentClassStyle = "";
            this.classStyle.getProcessingConditionsClassStyle = ""

            this.getHiddenDangerSectionshadow="always";
            var chartDom = document.getElementById('mychart');
            var myChart = echarts.init(chartDom);
            let data = []
            lccreq.getHiddenDangerSection().then(res =>{
                if(res.code == 200){
                    console.log(res.data.data)
                    for(let key in res.data.data){
                      let temp =  {
                            value: res.data.data[key],
                            name: key
                        }
                        data.push(temp)
                    }
                    this.option.series[0].data = [].concat(data)
                    this.option.title.text = '隐患标段'
                    myChart.setOption(this.option)
                }
            })
        },
        getTaskAssignment(){
            this.shadow.getTaskAssignmentshadow = "always";
            this.classStyle.getTaskAssignmentClassStyle = "classStyle";
            this.shadow.getHiddenDangerSectionshadow = "hover";
            this.shadow.getUnitPatrollingshadow = "hover";
            this.shadow.getProcessingConditionsshadow = "hover";
            this.classStyle.getHiddenDangerSectionClassStyle = ""
            this.classStyle.getUnitPatrollingVClassStyle = "";
            this.classStyle.getProcessingConditionsClassStyle = ""

            var chartDom = document.getElementById('mychart');
            var myChart = echarts.init(chartDom);
            let data = []
            lccreq.getTaskAssignment().then(res =>{
                if(res.code == 200){
                    console.log(res.data.data)
                    for(let key in res.data.data){
                      let temp =  {
                            value: res.data.data[key],
                            name: key
                        }
                        data.push(temp)
                    }
                    this.option.series[0].data = [].concat(data)
                    this.option.title.text = '任务分派'
                    myChart.setOption(this.option)
                }
            })
        },
        getProcessingConditions(){
            this.shadow.getProcessingConditionsshadow = "always";
            this.classStyle.getProcessingConditionsClassStyle = "classStyle"
            this.shadow.getHiddenDangerSectionshadow = "hover";
            this.shadow.getUnitPatrollingshadow = "hover";
            this.shadow.getTaskAssignmentshadow = "hover";
            this.classStyle.getHiddenDangerSectionClassStyle = ""
            this.classStyle.getUnitPatrollingVClassStyle = "";
            this.classStyle.getTaskAssignmentClassStyle = "";

            var chartDom = document.getElementById('mychart');
            var myChart = echarts.init(chartDom);
            let data = []
            lccreq.getProcessingConditions().then(res =>{
                if(res.code == 200){
                    console.log(res.data.data)
                    for(let key in res.data.data){
                      let temp =  {
                            value: res.data.data[key],
                            name: key
                        }
                        data.push(temp)
                    }
                    this.option.series[0].data = [].concat(data)
                    this.option.title.text = '处理状况统计'
                    myChart.setOption(this.option)
                }
            })
        },
    },
}
</script>
<style scoped>
    .classStyle {
        background-color:#409EFF;
    }
</style>


// WEBPACK FOOTER //
// src/views/safety/vor4.vue